import { getUserData } from "../assets/Js/tokenHandler";

const role = {
  owner: "owner",
  athlete: "athlete",
};

export function useRoleHandler() {
  return ({ forAthlete, forOwner }) => {
    const { Role } = getUserData();

    if (Role === role.owner) {
      return forOwner && typeof forOwner === "function" && forOwner();
    } else if (Role === role.athlete) {
      return forAthlete && typeof forAthlete === "function" && forAthlete();
    }
  };
}
